/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import axios from 'axios';
import snakecaseKeys from 'snakecase-keys';
import camelcaseKeys from 'camelcase-keys';

const http = axios.create({
    // TODO: Move this to some config file.
    baseURL: 'https://affiliator.mysterium.network/api/v1/',
    // baseURL: 'http://localhost:8080/api/v1/',
    timeout: 10000,
});

http.interceptors.response.use(
    (res: any) => res,
    (err: any) => {
        throw err;
    }
);

const convertOptions = {
    deep: true,
};

http.interceptors.request.use((config: any) => {
    if (config?.params) {
        config.params = snakecaseKeys(config.params, convertOptions);
    }
    if (config?.data) {
        config.data = snakecaseKeys(config.data, convertOptions);
    }
    return config;
});

http.interceptors.response.use((config: any) => {
    if (config?.data) {
        config.data = camelcaseKeys(config.data, convertOptions);
    }
    return config;
});

export default http;
